import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  List,
  ListItem,
  Typography,
} from "@mui/material";
// import Image from "next/image";
import React, { useRef, useState } from "react";
// import styles from "@/styles/pages/home.module.scss";
import styles from "../../../../styles/pages/home.module.scss";
// import assest from "@/json/assest";
import assest from "../../../../json/assest";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ApiLoader from "../../../Loaders/ApiLoader";
import ExpandedIcon from "../../../../ui/Icons/ExpandedIcon";
import NOprofileImage from "../../../../public/assets/images/no-profile-picture-Just.png";

// export type ExpensesAccordionBoxDataType = {
//   img: string;
//   title: string;
//   email: string;
//   price: string;
//   Outstanding_Balance: string;
//   Current_Earnings: string;
//   Payable_Amount: string;
//   bonus: string;
//   Correction: string;
// };
// type ExpensesAccordionBoxProps = {
//   data: Array<Partial<ExpensesAccordionBoxDataType>>;
//   title:string;
//   image:any;
// };
// export default function ExpensesAccordionBox(props: ExpensesAccordionBoxProps) {
export default function ExpensesAccordionBox(props) {
  const { data, title, image, isLoading, ref } = props;

  // const ref = useRef(null);
  const [showMore, setShowMore] = useState(false);
  const [range, setRange] = useState(3);

  const showMoreHandler = () => {
    if (range < data.length) {
      setRange((prevRange) => prevRange + 3);
    } else {
      ref?.current?.scrollIntoView({ behavior: "smooth" });
      setRange(3);
    }
  };

  const showLessHandler = () => {
    setRange((prevRange) => prevRange - 3);
  };

  const imageBaseUrl = "https://vsclips.s3.us-east-2.amazonaws.com";
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<img src={assest.plusicon} width={17} height={19} alt="" />}
        className={styles.accordian_heading}
        onClick={props.roleIdHandler}
      >
        <Box className={styles.expensesHeading}>
          <Box className={styles.expensesHeadingImg}>{image}</Box>
          <h4>{title}</h4>
        </Box>
      </AccordionSummary>
      <AccordionDetails className={styles.accordian_details}>
        <List className={styles.accordian_heading_box_sec}>
          <ListItem></ListItem>
          <ListItem>Name</ListItem>
          <ListItem>Payable Amount</ListItem>
        </List>

        {!isLoading && data && data?.length > 0 ? (
          data.slice(0, range).map((item, index) => {
            const { name, last_name, avatar, earnings, email } = item;
            return (
              <Accordion key={index} className={styles.accordian_details_box}>
                <AccordionSummary
                  expandIcon={<ExpandedIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Box className={styles.accordian_heading_box}>
                    {item?.avatar === "users/default.png" ? (
                      <img
                        // src={assest.partner1}
                        src={NOprofileImage}
                        alt=""
                        width={33}
                        height={33}
                      />
                    ) : (
                      <img
                        // src={assest.partner1}
                        src={
                          item?.avatar ? `${imageBaseUrl}/${item?.avatar}` : {}
                        }
                        alt=""
                        width={33}
                        height={33}
                      />
                    )}
                    {/*  <img
                      // src={assest.partner1}
                      src={
                        item?.avatar ? `${imageBaseUrl}/${item?.avatar}` : {}
                      }
                      alt=""
                      width={33}
                      height={33}
                    /> */}
                    <Box className={styles.middle_cont}>
                      <Typography variant="h2">{`${item?.name ?? ""} ${
                        item?.last_name ?? ""
                      }`}</Typography>
                      {item?.email && (
                        <Typography variant="h3">
                          Email address: {item?.email}
                        </Typography>
                      )}
                    </Box>
                    {item?.earnings && (
                      <Typography variant="h4">
                        ${item?.earnings[0]?.total ?? 0}
                      </Typography>
                    )}
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    {item?.earnings && (
                      <List className={styles.accordian_details_cont}>
                        {/* <ListItem>
                        <Typography variant="h2">
                          Outstanding Balance:
                        </Typography>
                        <Typography variant="h2">
                          {item?.Outstanding_Balance}
                        </Typography>
                      </ListItem> */}
                        {/* <ListItem>
                        <Typography variant="h2">Correction:</Typography>
                        <Typography variant="h2">{item?.Correction}</Typography>
                      </ListItem> */}
                        <ListItem>
                          <Typography variant="h2">
                            Current Earnings:
                          </Typography>
                          <Typography variant="h2">
                            {item?.earnings[0]?.amount ?? 0}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="h2">Bonus:</Typography>
                          <Typography variant="h2">
                            {item?.earnings[0]?.bonus ?? 0}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="h2">Payable Amount:</Typography>
                          <Typography variant="h2">
                            {item?.earnings[0]?.total ?? 0}
                          </Typography>
                        </ListItem>
                      </List>
                    )}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            );
          })
        ) : (
          <ApiLoader loading={isLoading} />
        )}
      </AccordionDetails>
      {data.length > 3 ? (
        <Box className={styles.show_more}>
          <Typography variant="h2" onClick={showLessHandler}>
            {range > 5 && range < data.length ? "Show less" : ""}
          </Typography>
          <Typography variant="h2" onClick={showMoreHandler}>
            {range < data.length ? "Show more" : "Show less"}
          </Typography>
        </Box>
      ) : null}
    </Accordion>
  );
}
